import { message } from "antd";
import { axiosGet, axiosPatch, axiosPost } from "../axios";

export const register = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/register-agent",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const check = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/check",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const agentLogin = async (payload) => {
  try {
    const res = await axiosPost({ path: "auth/login-agent", payload: payload });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const adminLogin = async (payload) => {
  try {
    const res = await axiosPost({ path: "auth/login-admin", payload: payload });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getAgent = async (id) => {
  try {
    const res = await axiosGet({
      path: `agent/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const updateAgent = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `agent/${id}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getStates = async () => {
  try {
    const res = await axiosGet({
      path: "state",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getUsers = async () => {
  try {
    const res = await axiosGet({
      path: "login-user",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const emailVerification = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/verify-otp",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const resendOtp = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/resend-otp",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const forgotPassword = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/forgot-password",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const confirmPassword = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/confirm-password",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const changePassword = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/change-password",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const logout = async (payload) => {
  try {
    const res = await axiosPost({
      path: "auth/logout",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
